






















import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import SubNavigationItem from '@/webcomponents/header/SubNavigationItem.vue';
import { Watch } from 'vue-property-decorator';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';
import '@/common/ts/plugins/vue-plugins';

const CloseIcon = () => import('@/common/icons/close-new.svg');

const SubNavigationProps = Vue.extend({
  props: {
    subNavigationItems: Array as () => Array<SubNavigationItem>,
    activeSubNavItemName: String,
  },
});

@Component({
  components: {
    CloseIcon,
  },
})
export default class SubNavigation extends mixins(SubNavigationProps) {
  $refs!: {
    items: HTMLElement;
    closeButton: HTMLButtonElement;
  };

  itemClass (item: SubNavigationItem) {
    return {
      'brandhub-sub-navigation__item--active': item.itemText === this.activeSubNavItemName,
    };
  }

  onSubItemClick (clickedItem: SubNavigationItem) {
    this.$emit('subnav-item-clicked', clickedItem);

    if (clickedItem.itemText) {
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Sub Navigation', clickedItem.itemText, clickedItem.itemLink);
    }
  }

  onClose () {
    this.$emit('sub-navigation-close');
  }

  mounted () {
    this.focusFirstSubItem();
  }

  @Watch('subNavigationItems')
  focusFirstSubItem () {
    this.$nextTick(() => {
      const { items } = this.$refs;
      if (items.children.length && navigator.maxTouchPoints < 1) {
        (items.firstChild as HTMLElement).focus();
      }
    });
  }

  get rootClass () {
    return {
      'brandhub-sub-navigation--active': !!this.activeSubNavItemName,
    };
  }
}
